import { gql } from '@apollo/client';

import baseFields from '../base';
import WORKTIMES from './worktimes';

const WORKDAYS = gql`
  ${WORKTIMES}
  fragment Workdays on Workday {
    ${baseFields}
    day
    availability
    worktimes {
      ...Worktimes
    }
  }
`;

export default WORKDAYS;
